import { PaginationProps, TableOptions } from '@/types';
import { default_pagination_props, default_table_opts } from '@/utils';

/**
 * Базовый класс с полями, которые нужны в каждом модуле vuex.
 * Пагинация, настройка таблиц
 */
export class BaseState {
  get create_pagination_props() {
    return default_pagination_props();
  }

  get create_table_opts() {
    return default_table_opts();
  }

  table_options: TableOptions = this.create_table_opts;
  pagination_props: PaginationProps = this.create_pagination_props;
}
